import axios from 'axios'

const url = '/api/getProductsSearch'

export const getShelfs = async (braindwObject: BraindwObjectProps[]) => {
  let promises = null

  if (!braindwObject) {
    return []
  }

  promises = braindwObject?.map(async (product: BraindwObjectProps) => {
    try {
      const response = await axios.post(url, product?.Products)

      return response.data
    } catch (error) {
      console.error(error)

      return null
    }
  })

  if (promises) {
    return Promise.all(promises)
  }

  return []
}
